export default {
  setShowMobileNav: (state, showMobileNav) => {
    state.showMobileNav = showMobileNav
  }
}
